<template>
    <div
        class="h4 py-2 px-2.5 font-medium pad:min-h-[4.375rem]"
        :class="disabled ? 'text-gray-200' :'text-gray-900'"
    >
        {{ text }}
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
};
</script>
